import EditionTabs from "./EditionTabs";

export default EditionTabs;
